export default "__VITE_ASSET__B1tyjZx2__"